import React, { useEffect} from 'react';
import { Modal, Button } from "antd";
import { UseVerConvocatorias } from "../../hooks/UseVerConvocatorias";
import PdfJurados from "../../assets/Condiciones generales_ 1a convocatoria base de jurados 2025_def (1).pdf"
import PdfLEP from "../../assets/VF_condiciones_generales_recurso_LEP_2025.pdf"
import PdfOrdi from "../../assets/VF_condiciones_generales_recurso_ordinario_2025.pdf"

interface IProps {
  visualizar: boolean;
  setVisualizar: any;
  nombre: any
}

export const ModalCondicionesGenerales: React.FC<IProps> = (props: IProps) => {

  const onCancel = () => {
    props.setVisualizar(false)
  }

    const {
      getConvocatoriaPersistente,
      convocatoriaPersitente: convocatoria,
    } = UseVerConvocatorias();

    useEffect(() => {
      //getConvocatoriaPersistente();
    }, []);

  return (
    <Modal
      className="ant-modal-close-x2"
      maskStyle={{
        backgroundColor: "rgba(6, 100, 144 ,0.71)",
      }}
      visible={props.visualizar}
      onCancel={onCancel}
      width={800}
      footer={[
        <Button key="B_CERRAR_1" className="button-gray-ghost m-0" onClick={onCancel}>
          Cerrar
        </Button>,
      ]}
      cancelButtonProps={{ style: { display: "none" } }}
    >
      <div style={{ textAlign: 'center', fontSize: '1.2em', height: '600px' }}>
        <p style={{ fontSize: '1.5em', fontWeight: 'bold' }}>
          ¡Por favor leer las condiciones generales!
        </p>
        {props.nombre == null ? (
          <div>
            <p>Jurados:</p>
            <iframe src={PdfJurados} style={{ width: '100%', height: '500px' }}></iframe>
          </div>
        ) : props.nombre.includes('Ley de espectáculos públicos') ? (
          <div>
            <p>LEP:</p>
            <iframe src={PdfLEP} style={{ width: '100%', height: '500px' }}></iframe>
          </div>
        ) : (
          <div>
            <p>Ordinario:</p>
            <iframe src={PdfOrdi} style={{ width: '100%', height: '500px' }}></iframe>
          </div>
        )}
      </div>
    </Modal>
  );
};
